<template>
    <div>
        <div class="dbb-field">
            <label>Table</label>
            <b-form-select v-model="table" :options="tables" @change="onTableChange" />
        </div>

        <div v-if="table">
            <database
                :key="table"
                :start_table="table"
                :name="false"
                :edit="false"
                ref="database"></database>
        </div>

        <hr class="my-3">
        <div class="dbb-field">
            <label style="font-size:0.85em;font-weight:700;text-transform:uppercase;color:#555;">
                <i class="fas fa-chart-bar"></i> Graphique
            </label>
            <b-checkbox v-model="chart.enable" class="mb-2">Activer le graphique</b-checkbox>
            <div v-if="chart.enable">
                <label class="mt-2">Vue par défaut</label>
                <b-select v-model="chart.default_view"
                    :options="[{value:'table',text:'Tableau'},{value:'chart',text:'Graphique'}]" />
                <chart-config ref="chartConfig" :value="chart.charts" :columns="tableColumns" :context="'table - ' + table" @input="v => chart = { ...chart, charts: v }" />
                <b-button size="sm" variant="outline-primary" class="mt-2" @click="loadPreview">
                    <i class="fas fa-eye"></i> Aperçu du graphique
                </b-button>
                <div v-if="previewData.length > 0 && chart.charts[previewChartIndex]" class="mt-2">
                    <chart-display :key="previewKey"
                        :rows="previewData" :config="chart.charts[previewChartIndex]" :editable="false" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import database from "../../views/database.vue";
import ChartConfig, { defaultChartConfig } from "../ChartConfig.vue";
import ChartDisplay from "../ChartDisplay.vue";

export default {
    components: { database, ChartConfig, ChartDisplay },
    props: { params: {} },
    data() {
        return {
            table: null,
            tables: [],
            tableColumns: [],
            previewData: [],
            previewKey: 0,
            previewChartIndex: 0,
            chart: {
                enable: false,
                default_view: 'table',
                charts: [defaultChartConfig()]
            }
        };
    },
    methods: {
        async onTableChange() {
            this.previewData = [];
            await this.$nextTick();
            await this.$nextTick();
            // Attendre les colonnes
            const start = Date.now();
            while (Date.now() - start < 3000) {
                if (this.$refs.database && this.$refs.database.options_columns && this.$refs.database.options_columns.length > 0) {
                    this.tableColumns = this.$refs.database.options_columns;
                    break;
                }
                await new Promise(r => setTimeout(r, 50));
            }
        },
        loadPreview() {
            this.previewKey++;
            this.previewChartIndex = this.$refs.chartConfig ? this.$refs.chartConfig.activeTab : 0;
            this.previewData = (this.$refs.database && this.$refs.database.data) ? this.$refs.database.data : [];
        },
        async save() {
            let config = null;
            if (this.$refs.database && this.$refs.database.save) {
                config = await this.$refs.database.save();
            }
            return {
                table: this.table,
                config,
                chart: this.chart.enable ? { ...this.chart } : null
            };
        },
        async load(data) {
            if (!data) return;
            this.table = data.table || null;
            if (data.chart) {
                const d = data.chart;
                if (d.charts && d.charts.length) {
                    // Format actuel
                    this.chart = { ...this.chart, ...d };
                } else {
                    // Ancien format plat { type, data_mode, ... }
                    this.chart = {
                        enable: !!d.enable,
                        default_view: d.default_view || 'table',
                        charts: [{
                            ...defaultChartConfig(),
                            type:            d.type            || 'pie',
                            data_mode:       d.data_mode       || 'count',
                            label_col:       d.label_col       || '',
                            date_trunc:      d.date_trunc      || false,
                            date_trunc_unit: d.date_trunc_unit || 'day',
                            value_col:       d.value_col       || '',
                            series_col:      d.series_col      || '',
                            title:           d.title           || ''
                        }]
                    };
                }
            }

            if (this.table && data.config) {
                await this.$nextTick();
                await this.$nextTick();

                // Attendre l'init du composant database
                const maxWait = 3000;
                const start   = Date.now();
                while (Date.now() - start < maxWait) {
                    if (this.$refs.database &&
                        this.$refs.database.options_columns &&
                        this.$refs.database.options_columns.length > 0) break;
                    await new Promise(r => setTimeout(r, 50));
                }

                if (this.$refs.database && this.$refs.database.load) {
                    await this.$refs.database.load(data.config, data.table);
                }
                // Colonnes disponibles après le chargement
                if (this.$refs.database && this.$refs.database.options_columns) {
                    this.tableColumns = this.$refs.database.options_columns;
                }
            }
        }
    },
    async mounted() {
        var response = await this.$store.getters.getClient;
        if (response && response.details && response.details.tables) {
            this.tables = response.details.tables.map(t => t.name);
        }
        if (this.params) {
            this.load(this.params);
        }
    }
};
</script>
